(function (win, $) {
    'use strict';
    var fp = (win.fp = typeof win.fp !== 'undefined' ? win.fp : {}),
        home = (fp.home = typeof fp.home !== 'undefined' ? fp.home : {});

    fp.home = (function () {

        // =========================================
        // Set Hero Size
        // =========================================
        var setHeroSize = function (initialLoad) {
            var height = $(window).height();
            var headerHeight = $('header').outerHeight() || 0; // Fallback to 0 if header doesn't exist
            var specialMessageHeight = 0;
            var fixedFooterHeight = 0;
            var logoMobileHeight = 0;

            // Calculate special message height if visible
            var specialMessage = $('#special-message.message-banner');
            if (specialMessage.length && specialMessage.is(':visible')) {
                specialMessageHeight = specialMessage.outerHeight();
            }

            // Calculate fixed footer height if visible
            var fixedFooter = $('#fixed-footer');
            if (fixedFooter.length && fixedFooter.is(':visible')) {
                fixedFooterHeight = fixedFooter.outerHeight();
            }

            // Calculate logo mobile height if visible
            var logoMobile = $('#logo-mobile');
            if (logoMobile.length && logoMobile.is(':visible')) {
                logoMobileHeight = logoMobile.outerHeight();
            }

            // Check responsive state using width-detection
            var floatValue = $('#width-detection').css('float');
            if (floatValue !== 'none') {
                var minHeight = height - specialMessageHeight - headerHeight - fixedFooterHeight - logoMobileHeight;
                $('#hero .cycle-slideshow').css('min-height', minHeight);
                $('#hero').css('min-height', minHeight);
            } else {
                $('#hero').css('min-height', 'auto');
                $('#hero .cycle-slideshow').css('min-height', 'auto');
            }

            // Initial load logic
            if (initialLoad) {
                $('body').removeClass('fade-home-contents');
            }
        };

        // =========================================
        // Observe Special Message Visibility
        // =========================================
        var observeSpecialMessage = function () {
            var specialMessage = document.querySelector('#special-message.message-banner');

            if (!specialMessage) {
                return; // Exit if #special-message.message-banner doesn't exist
            }

            var observer = new MutationObserver(function () {
                if (specialMessage.style.display !== 'none' && $(specialMessage).is(':visible')) {
                    observer.disconnect(); // Stop observing once visible
                    setHeroSize(false); // Recalculate hero size
                }
            });

            // Start observing the element for visibility changes
            observer.observe(specialMessage, { attributes: true, childList: false, subtree: false });
        };

        // =========================================
        // Set video controls
        // =========================================
        var setupVideoControls = function () {
            var video = document.getElementById('bg-video');
            var videoButton = document.getElementById('video-pause-play');
            var videoButtonIcon = videoButton ? videoButton.querySelector('span') : null;
            var controlAnnouncements = document.getElementById('video-control-announcements');

            if (!video || !videoButton || !controlAnnouncements) {
                return;
            }

            videoButton.addEventListener('click', function () {
                if (!video.paused) {
                    video.pause();
                    videoButton.setAttribute('aria-label', 'Play video');
                    videoButtonIcon.classList.replace('icon-pause', 'icon-play');
                    controlAnnouncements.textContent = 'Video paused';
                } else {
                    video.play();
                    videoButton.setAttribute('aria-label', 'Pause video');
                    videoButtonIcon.classList.replace('icon-play', 'icon-pause');
                    controlAnnouncements.textContent = 'Video playing';
                }
            });
        };

        // =========================================
        // Set up carousel controls
        // =========================================

        const setupCarouselControls = () => {
            const carouselWrapper = document.querySelector('.slideshow');
            const carouselTarget = document.querySelector('.cycle-slideshow');
            const ariaLiveRegion = document.querySelector('#control-announcements');

            // Ensure the carousel target exists and the cycle plugin is available
            if (!carouselTarget || typeof $.fn.cycle !== 'function') return;

            // Initialize the carousel
            $(carouselTarget).cycle();

            // Pause the carousel on mouseenter
            /*
            if (carouselWrapper) {
                carouselWrapper.addEventListener('mouseenter', () => {
                    if (!carouselTarget.classList.contains('hard-pause')) {
                        $(carouselTarget).cycle('pause');
                    }
                });

                carouselWrapper.addEventListener('mouseleave', () => {
                    if (!carouselTarget.classList.contains('hard-pause')) {
                        $(carouselTarget).cycle('resume');
                    }
                });
            }
            */

            // Handle the play/pause button
            const cyclePausePlay = document.querySelector('#cycle-pause-play');
            const cyclePausePlayIcon = cyclePausePlay ? cyclePausePlay.querySelector('span') : null;

            if (cyclePausePlay) {
                cyclePausePlay.addEventListener('click', function () {
                    const isPaused = carouselTarget.classList.contains('hard-pause');

                    // Update play/pause state
                    if (isPaused) {
                        carouselTarget.classList.remove('hard-pause');
                        this.setAttribute('aria-label', 'Pause carousel');
                        if (cyclePausePlayIcon) {
                            cyclePausePlayIcon.classList.replace('icon-play', 'icon-pause');
                        }
                        ariaLiveRegion.textContent = 'Carousel is playing.';
                        $(carouselTarget).cycle('resume');
                    } else {
                        carouselTarget.classList.add('hard-pause');
                        this.setAttribute('aria-label', 'Play carousel');
                        if (cyclePausePlayIcon) {
                            cyclePausePlayIcon.classList.replace('icon-pause', 'icon-play');
                        }
                        ariaLiveRegion.textContent = 'Carousel is paused.';
                        $(carouselTarget).cycle('pause');
                    }
                });
            }

            // Handle the "Back" button
            const cycleBack = document.querySelector('#cycle-back');
            if (cycleBack && ariaLiveRegion) {
                cycleBack.addEventListener('click', () => {
                    ariaLiveRegion.textContent = 'Reading previous slide.';
                });
            }

            // Handle the "Next" button
            const cycleNext = document.querySelector('#cycle-next');
            if (cycleNext && ariaLiveRegion) {
                cycleNext.addEventListener('click', () => {
                    ariaLiveRegion.textContent = 'Reading next slide.';
                });
            }
        };

        // =========================================
        // Set menu button
        // =========================================
        var setupMenuButton = function () {
            var menuListButton = $('#show-menus-button');

            if (!menuListButton.length) {
                return;
            }

            menuListButton.click(function () {
                var button = $(this);
                $('#list-of-menus').slideToggle();

                button.toggleClass('menus-open');
                var isOpen = button.hasClass('menus-open');
                button.text(isOpen ? 'Hide Menus' : 'Select a Menu')
                    .attr('aria-expanded', isOpen);

                return false;
            });
        };

        // Public API
        return {
            init: function () {
                // Set selected nav
                $('.homepage-link').addClass('selected');

                // Initialize menus
                setupMenuButton();

                // Initialize hero and slideshow
                setHeroSize(true); // Trigger on initial load
                observeSpecialMessage(); // Watch for #special-message.message-banner visibility changes
                $(window).resize(function () {
                    setHeroSize(false);
                });

                // Initialize carousel controls
                setupCarouselControls();

                // Initialize video controls
                setupVideoControls();
            }
        };
    })();
})(window, $);